//CSS
import "../../Components/Page/Page.css";
import "../LandingNews/LandingNews.css";

//React
import React from "react";
import { Link } from "react-router-dom";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NewsReleases from "../../Components/Article/NewsReleases.json";

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString("en-US", { month: "long", year: "numeric" });

const FEATURED_INDEXES = [0, 5];

const Featured: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="Featured Releases" />

      <SubSection isSplit={false}>
        <div className="landing-news-grid">
          {FEATURED_INDEXES.map((int) => {
            const item = NewsReleases[int];
            return (
              <Link key={item.slug} to={`/article/${item.slug}`} className="landing-news-card">
                <div className="landing-news-card-tags">
                  {item.tags?.slice(0, 2).map((tag) => (
                    <span key={tag} className="landing-news-tag">{tag}</span>
                  ))}
                </div>
                <h3 className="landing-news-card-title">{item.title}</h3>
                <p className="landing-news-card-excerpt">{item.excerpt}</p>
                <div className="landing-news-card-footer">
                  <span className="landing-news-date">
                    {item.publishedAt ? formatDate(item.publishedAt) : null}
                  </span>
                </div>
                <span className="landing-news-read-more">
                  Read more <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </Link>
            );
          })}
        </div>
      </SubSection>
    </div>
  );
};

export default Featured;
